import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    const paymentId = this.element.dataset.registrationStatusPaymentId
    const maxAttempts = Number(this.element.dataset.registrationStatusMaxAttempts || 10)
    this.storageKey = `event-payment-status-${paymentId}`

    const attempts = Number(window.sessionStorage.getItem(this.storageKey) || 0)
    if (attempts >= maxAttempts) return

    this.refreshTimer = window.setTimeout(() => {
      window.sessionStorage.setItem(this.storageKey, attempts + 1)
      window.location.reload()
    }, 3000)
  }

  disconnect() {
    if (this.refreshTimer) window.clearTimeout(this.refreshTimer)
  }
}
